import React, { useEffect, useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { getUser, logout } from '../../auth/authService';
import './Restricted.css';

const Restricted = () => {
    const [email, setEmail] = useState(null);

    useEffect(() => {
        const load = async () => {
            const user = await getUser();
            setEmail(user?.profile?.email ?? null);
        };
        load();
    }, []);

    return (
        <Box className="restricted-container cc">
            <Box className="restricted-card cc" sx={{ flexDirection: 'column', gap: 2 }}>
                <LockOutlinedIcon sx={{ fontSize: 48, color: '#004df2' }} />
                <Typography className="nexus-font lg">Access Restricted</Typography>
                <Typography className="d-font md restricted-sub">
                    Your account{email ? ` (${email})` : ''} does not have permission to access Nexus Super.
                </Typography>
                <Button
                    variant="outlined"
                    className="d-font"
                    onClick={logout}
                    sx={{ mt: 1 }}
                >
                    Sign out
                </Button>
            </Box>
        </Box>
    );
};

export default Restricted;
